export const FONT_SCALE_STEPS = Object.freeze([0.4, 0.6, 0.8, 1, 1.2, 1.4, 1.8, 2, 2.5, 3.2, 4, 5]);

export const FONT_SCALE_CHANGE_TYPE = Object.freeze({
  increase: '+1',
  decrease: '-1',
});
